if (!customElements.get("carousel-component")) {
  class Carousel extends HTMLElement {
    constructor() {
      super();

      this.progressBar = document.getElementById(this.id.replace('carousel-', 'progress-'));
      this.thumbsSlider = document.getElementById(this.id.replace('carousel-', 'thumbs-'));

      // Configurations
      this.desktopPerPage = this.dataset['desktopperpage'] || 4;
      this.mobilePerPage = this.dataset['mobileperpage'] || 1;
      this.type = this.dataset['type'] || 'slide';
      this.perMove = this.dataset['perMove'] || 1;
      this.gap = this.dataset['gapbetweenslides'] || 10;
      this.gapMobile = this.dataset['gapbetweenslidesonmobile'] || 10;
      this.mobilePaddingLeft = this.dataset['mobilepaddingleft'] || '0';
      this.desktopPaddingLeft = this.dataset['desktoppaddingleft'] || '0';
      this.mobilePaddingRight = this.dataset['mobilepaddingright'] || '0';
      this.desktopPaddingRight = this.dataset['desktoppaddingright'] || '0';

      // Handle boolean values from data attributes
      this.showarrows = this.dataset['showarrows'] === 'true' || false;
      this.showarrowsonmobile = this.dataset['showarrowsonmobile'] === 'true' || false;
      this.showdots = this.dataset['showdots'] === 'true' || false;
      this.showdotsonmobile = this.dataset['showdotsonmobile'] === 'true' || false;
      this.mobileOnly = this.dataset['mobileonly'] === 'true' || false;
      this.desktopOnly = this.dataset['desktoponly'] === 'true' || false;
    }

    connectedCallback() {
      // Initialize carousel for both mobile and desktop
      this.carousel = new Splide(this, {
        type: this.type,
        perPage: this.desktopPerPage,
        perMove: this.perMove,
        gap: this.gap,
        arrows: this.showarrows,
        pagination: this.showdots,
        padding: {
          left: this.desktopPaddingLeft,
          right: this.desktopPaddingRight
        },
        // desktop settings
        destroy: this.mobileOnly,
        breakpoints: {
          // Settings for mobile screens
          768: {
            padding: {
              left: this.mobilePaddingLeft,
              right: this.mobilePaddingRight
            },
            perPage: this.mobilePerPage,
            arrows: this.showarrowsonmobile,
            pagination: this.showdotsonmobile,
            gap: this.gapMobile,
            // mobile settings
            destroy: this.desktopOnly,

          }
        },
      });
      // Skip mounting as the progress bar will manage its own Splide mounting
      if (!this.progressBar && !this.thumbsSlider)
        this.carousel.mount();
    }
  }

  customElements.define('carousel-component', Carousel);

  class CarouselProgress extends HTMLElement {
    constructor() {
      super();
      this.progressBar = this.querySelector('div');
    }

    connectedCallback() {
      const progressBarEl = this.progressBar;
      const splide = document.getElementById(this.id.replace('progress-', 'carousel-'))?.carousel;
      if (!splide) return console.error(`Splide instance not found for ${this.id}`);

      const ProgressBar = (splide) => {
        function progressBar() {
          const rate = (splide.index + 1) / (splide.Components.Controller.getEnd() + 1);
          progressBarEl.style.width = `${Math.min(rate, 1) * 100}%`;
        }
        return {
          mount() {
            splide.on("mounted move", progressBar);
          }
        };
      };

      splide.mount({ ProgressBar });
    }
  }

  customElements.define('carousel-progress', CarouselProgress);

  class CarouselThumbs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const splide = document.getElementById(this.id.replace('thumbs-', 'carousel-'))?.carousel;
      if (!splide) return console.error(`Splide instance not found for ${this.id}`);

      const thumbnails = new Splide(this, {
        perPage: 5,
        gap: 16,
        rewind: true,
        pagination: false,
        isNavigation: true,
        arrows: false,
        breakpoints: {
          // Settings for mobile screens
          768: {
            gap: 8,
          }
        },
      });

      splide.sync(thumbnails);
      splide.mount();
      thumbnails.mount();
    }
  }

  customElements.define('carousel-thumbs', CarouselThumbs);
}